module.exports = __webpack_public_path__ + "media/src/images/upload-area-244888cd7df7e6aa475edf60b008fc13.png";